export const ArtisaiConst = Object.freeze({
  ARTISAI_SRC:
    'https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=content&pixid=9a6c1f5d-48a4-4268-aff9-5be054085773',
});

export const pixelAllowedRoutes: string[] = ['/users/new/form', '/welcome', '/accounts/open/form'];
